import Revelar from './Revelar';
import styles from './LandingBase.module.css';

const perguntas = [
  {
    pergunta: 'Ainda vou precisar de planilha?',
    resposta:
      'Não. O Finant faz o trabalho que você faria na planilha: reúne contas, cartões e gastos, calcula saldos e organiza tudo por categoria, sem fórmula e sem manutenção manual.'
  },
  {
    pergunta: 'Como o Finant me dá clareza dos gastos?',
    resposta:
      'Cada lançamento entra em uma categoria, e o dashboard mostra pra onde seu dinheiro foi no período, compara com o período anterior e destaca insights automáticos, como o maior gasto do mês e quanto do total é despesa fixa.'
  },
  {
    pergunta: 'Dá pra prever meus meses e acompanhar metas?',
    resposta:
      'Sim. O dashboard projeta como o mês vai fechar no seu ritmo atual de gastos. E as metas por categoria, que o app pode sugerir pela sua média, mostram sinal vermelho na hora que estouram. Chega de meses imprevisíveis.'
  },
  {
    pergunta: 'Como funciona com cartão de crédito?',
    resposta:
      'Cada cartão tem fatura estimada do ciclo, calculada pela data de fechamento, além de limite e vencimento sempre à vista. Você sabe o tamanho da fatura antes de ela fechar.'
  },
  {
    pergunta: 'Preciso saber de finanças pra usar?',
    resposta:
      'Não. A ideia é ser simples. Você cria a conta, lança gastos em segundos, e o app organiza tudo em dashboards fáceis de entender.'
  },
  {
    pergunta: 'Meus dados estão seguros?',
    resposta: 'Sim. Seus dados são protegidos com criptografia e ficam sob o seu controle. Você decide o que registrar e pode apagar quando quiser.'
  },
  {
    pergunta: 'Como começo a usar?',
    resposta: 'É só criar uma conta e registrar suas primeiras contas e gastos. Leva menos de dois minutos e não precisa de cartão pra começar.'
  }
];

const Questions = () => {
  return (
    <section id="perguntas" className={styles.section}>
      <Revelar>
        <div className={styles.sectionHead}>
          <span className={styles.eyebrow}>Perguntas</span>
          <h2 className={styles.sectionTitle}>Perguntas frequentes</h2>
          <p className={styles.sectionSub}>Tudo que você precisa saber sobre o Finant.</p>
        </div>
      </Revelar>

      <div className={styles.faqList}>
        {perguntas.map((p, i) => (
          <Revelar key={p.pergunta} atraso={i * 50}>
            <details className={styles.faqItem}>
              <summary className={styles.faqQ}>
                {p.pergunta}
                <span className={`${styles.faqChevron} material-symbols-rounded`}>expand_more</span>
              </summary>
              <p className={styles.faqA}>{p.resposta}</p>
            </details>
          </Revelar>
        ))}
      </div>
    </section>
  );
};

export default Questions;
